import { bugsnagClient } from '@/bugsnag';

export default {
  cachePrefix: 'rmp',

  cacheVersion: 'v1.8',

  resolveKey({ key }) {
    return `${this.cachePrefix}|${this.cacheVersion}|${key}`;
  },

  setSessionStorage({ key, items } = {}) {
    const resolvedKey = this.resolveKey({ key });

    try {
      sessionStorage.setItem(resolvedKey, JSON.stringify(items));
    } catch (e) {
      bugsnagClient.notify(e, { severity: 'info' });
    }
  },

  getSessionStorage({ key } = {}) {
    const resolvedKey = this.resolveKey({ key });

    try {
      const items = sessionStorage.getItem(resolvedKey);

      if (items !== null) {
        return JSON.parse(items);
      }
    } catch (e) {
      bugsnagClient.notify(e, { severity: 'info' });
    }
    return null;
  },

  emptySessionStorage({ key } = {}) {
    const resolvedKey = this.resolveKey({ key });

    try {
      sessionStorage.removeItem(resolvedKey);
    } catch (e) {
      bugsnagClient.notify(e, { severity: 'info' });
    }
  },

  setLocalStorage({ key, items } = {}) {
    const resolvedKey = this.resolveKey({ key });
    try {
      localStorage.setItem(resolvedKey, JSON.stringify(items));
    } catch (e) {
      bugsnagClient.notify(e, { severity: 'info' });
    }
  },

  getLocalStorage({ key } = {}) {
    const resolvedKey = this.resolveKey({ key });

    try {
      const items = localStorage.getItem(resolvedKey);

      if (items !== null) {
        return JSON.parse(items);
      }
    } catch (e) {
      bugsnagClient.notify(e, { severity: 'info' });
    }
    return [];
  },

  clearSessionOldKeys() {
    try {
      const sessionKeys = [
        'rmp|v1.4|saved-items|items',
      ];

      sessionKeys.forEach((key) => {
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
      });
    } catch (e) {
      bugsnagClient.notify(e, { severity: 'info' });
    }
  },
};
